export default "__VITE_ASSET__rycKmkyn__"